import React from 'react';
import { MessageCircle } from 'lucide-react';
import { SITE } from '../data/mock';

const WhatsAppFloat = () => (
  <a
    href={SITE.whatsappChannel}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Join our WhatsApp Channel"
    className="fixed bottom-6 right-6 z-40 group flex items-center gap-3"
  >
    <span className="hidden md:inline-block bg-white shadow-lg text-slate-800 text-sm font-semibold px-4 py-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap">
      Join our WhatsApp Channel
    </span>
    <span className="w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1da851] grid place-items-center text-white shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-110 animate-pulse-slow">
      <MessageCircle size={26} />
    </span>
  </a>
);

export default WhatsAppFloat;
